import { LEGAL_LAST_UPDATED } from '@/constants/site.constants';
import { TERMS_CONTENT } from '@/features/legal/constants/terms.constants';
import { useDocumentTitle } from '@/hooks/useDocumentTitle.hook';
import type { LegalDocumentContent } from '@/types/legal.types';

interface UseTermsPageResult {
  content: LegalDocumentContent;
  lastUpdated: string;
}

export const useTermsPage = (): UseTermsPageResult => {
  useDocumentTitle(
    'Terms & Conditions | Shoutt',
    'The terms that govern renting, lending and posting on Shoutt, the campus-only rental marketplace.',
  );

  return { content: TERMS_CONTENT, lastUpdated: LEGAL_LAST_UPDATED };
};
